module.exports = __webpack_public_path__ + "static/media/ArnoPro-Regular.06acbd8c.svg";